import React, { useEffect, useState } from 'react';
import { Box, Button, Grid, Paper, Stack, TextField, Typography } from '@mui/material';
import { ArrowForwardIos } from '@mui/icons-material';
import axios from 'axios';
import Notification from '../Notification';
import { useDispatch } from 'react-redux';
import { updateTableActions } from '../../store/update-table-slice';

function EditSalaryStructureHeader(props) {
  const dispatch = useDispatch();
  const [values, setValues] = useState({
    department: '',
    designation: '',
    contract_effective_date: ''
  });
  const [errors, setErrors] = useState({});
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: '' });

  useEffect(() => {
    setValues({
      department: props.initialDepartment || '',
      designation: props.initialDesignation || '',
      contract_effective_date: props.initialEffectiveDate || ''
    });
  }, [props.initialDepartment, props.initialDesignation, props.initialEffectiveDate]);

  function handleInputChange(e) {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
    if (errors[name]) setErrors({ ...errors, [name]: '' });
    if (notify.isOpen) setNotify({ isOpen: false, message: '', type: '' });
  }

  function validate() {
    const temp = {};
    if (!values.department?.trim()) temp.department = 'Department is required';
    if (!values.designation?.trim()) temp.designation = 'Designation is required';
    if (!values.contract_effective_date?.trim()) temp.contract_effective_date = 'Effective date is required';
    setErrors(temp);
    return Object.keys(temp).length === 0;
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!validate()) return;
    try {
      const url = `${process.env.REACT_APP_API_BASE_URL}/employee-master/update-employee-salary-structure/${props.employeeID}`;
      const payload = {
        designation: values.designation,
        department: values.department,
        contract_effective_date: values.contract_effective_date
      };
      const res = await axios.post(url, payload);
      if (res.status >= 200 && res.status < 300) {
        setNotify({ isOpen: true, message: res.data?.message || 'Updated successfully', type: 'success' });
        dispatch(updateTableActions.startUpdateEmpSalComponents());
        // Call onSuccess immediately to refresh table
        if (props.onSuccess) {
          props.onSuccess();
        }
        setTimeout(() => {
          props.onClose?.();
        }, 100);
      }
    } catch (e) {
      setNotify({ isOpen: true, message: e.response?.data?.message || 'Update failed', type: 'error' });
    }
  }

  return (
    <Box sx={{ display: "flex", justifyContent: "center", margin: "10px", marginTop: "-30px", padding: "30px" }}>
      <Paper elevation={5} sx={{ width: "500px" }}>
        <Grid container spacing={2} className="form-title">
          <Grid item>
            <Typography variant="h5" sx={{ textAlign: "center", margin: 5 }}>
              Edit Salary Structure
            </Typography>
          </Grid>
        </Grid>
        <form onSubmit={handleSubmit}>
          <Stack spacing={2} sx={{ margin: "30px" }}>
            <Stack className="form-input-row" direction="row" spacing={2}>
              <TextField
                variant="outlined"
                name="department"
                label="Department"
                size="small"
                value={values.department}
                onChange={handleInputChange}
                {...(errors.department && { error: true, helperText: errors.department })}
              />
              <TextField
                variant="outlined"
                name="designation"
                label="Designation"
                size="small"
                value={values.designation}
                onChange={handleInputChange}
                {...(errors.designation && { error: true, helperText: errors.designation })}
              />
            </Stack>
            <Stack className="form-input-row" direction="row" spacing={2}>
              <TextField
                variant="outlined"
                type="date"
                name="contract_effective_date"
                label="Effective Date"
                size="small"
                InputLabelProps={{ shrink: true }}
                disabled={!!props.disableEffectiveDate}
                value={values.contract_effective_date}
                onChange={handleInputChange}
                {...(errors.contract_effective_date && { error: true, helperText: errors.contract_effective_date })}
              />
            </Stack>
            <Stack display="flex" sx={{ alignItems: "flex-end" }}>
              <Button variant="contained" endIcon={<ArrowForwardIos />} type="submit">Save</Button>
            </Stack>
          </Stack>
        </form>
        <Notification notify={notify} setNotify={setNotify} />
      </Paper>
    </Box>
  );
}

export default EditSalaryStructureHeader;


